import { render, staticRenderFns } from "./AgoraVideoCall.vue?vue&type=template&id=18ccc1b0&"
import script from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
export * from "./AgoraVideoCall.vue?vue&type=script&lang=js&"
import style0 from "./AgoraVideoCall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports